import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantBillingRecordDto } from '../../billing/dtos/tenant-billing-record.dto';
import { PlatformContactDto } from '../../contacts/dtos/platform-contact.dto';
import { TenantStatusEnum } from '../enums/tenant-status.enum';

/**
 * Tenant DTO for records
 */
@CaslSubject(AppSubjectEnum.TENANT)
export class TenantRecordDto extends BaseDto {
  /** Lowered internal org id. */
  tenantOrgId!: string;
  /** Issued auth-provider organization id. */
  tenantAuthProviderOrgId!: string;
  tenantName!: string;
  tenantDatabase!: string;
  email!: string;
  appBaseUrl?: string;
  status!: TenantStatusEnum;
  contact!: PlatformContactDto;
  billing?: TenantBillingRecordDto;
  notes?: string;
  files?: FileDto[];
}
